import { Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataBindingDirective, GridModule } from '@progress/kendo-angular-grid';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import { ButtonsModule, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import {
  cartIcon,
  xCircleIcon,
  userIcon,
  envelopIcon,
  myspaceIcon,
  puzzlePieceIcon,
  SVGIcon,
  pencilIcon,
  searchIcon,
  arrowRotateCwIcon
} from '@progress/kendo-svg-icons';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { IconsModule, KENDO_ICONS } from '@progress/kendo-angular-icons';

import { ActivatedRoute, Router } from '@angular/router';
import { LabelModule } from '@progress/kendo-angular-label';
import { KENDO_LAYOUT, LayoutModule } from '@progress/kendo-angular-layout';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { IntlModule } from '@progress/kendo-angular-intl';
import { AuthUserService } from '../../shared/auth/auth-user.service';
import { Roles } from '../../constants/roles';
import { RequestService } from '../../services/request.service';
import { EngagementService } from '../../services/engagement.service';
import { RefreshGridService } from '../../shared/services/refresh-grid.service';
import { EngagementrequestService } from '../../services/engagementrequest.service';
import { UserrequestService } from '../../services/userrequest.service';
import { ModulerequestService } from '../../services/modulerequest.service';
import { RequestEngagementActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-engagement-activity-panel/request-engagement-activity-panel.component';
import { RequestModuleActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-module-activity-panel/request-module-activity-panel.component';
import { RequestAddUserActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-add-user-activity-panel/request-add-user-activity-panel.component';
import { RequestRemoveUserActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-remove-user-activity-panel/request-remove-user-activity-panel.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { AuthService } from '../../shared/auth/auth.service';
import { GridPagerSettings } from '../../models/common/gridPagerSettings.model';
import { DEFAULT_GRID_PAGER_SETTINGS } from '../../constants/gridPagerSettings';
import { RequestType } from '../../constants/requestType';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSpinnerService } from "ngx-spinner";
import {
  process,
} from '@progress/kendo-data-query';
import { RequestStatusEnum } from '../../enums/requestStatusEnum';
import { KENDO_TOOLTIPS } from '@progress/kendo-angular-tooltip';
import { Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-request',
  standalone: true,
  imports: [
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    KENDO_TOOLTIPS,
    CommonModule,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    GaugesModule,
    ProgressBarModule,
    IntlModule,
    RequestEngagementActivityPanelComponent,
    RequestAddUserActivityPanelComponent,
    DatePipe,
    RequestModuleActivityPanelComponent,
    RequestRemoveUserActivityPanelComponent,
    IndicatorsModule,
    FormsModule,
    NgxSpinnerModule
  ],
  templateUrl: './request.component.html',
  styleUrl: './request.component.scss'
})
export class RequestComponent implements OnDestroy {
  public puzzlePieceIcon: SVGIcon = puzzlePieceIcon;
  public myspaceIcon: SVGIcon = myspaceIcon;
  public envelopIcon: SVGIcon = envelopIcon;
  public svgCart: SVGIcon = cartIcon;
  public xCircle: SVGIcon = xCircleIcon;
  public svgUsr: SVGIcon = userIcon;
  public pencilIcon: SVGIcon = pencilIcon;
  public searchIcon: SVGIcon = searchIcon;
  public refresh: SVGIcon = arrowRotateCwIcon;
  public pagerSettings: GridPagerSettings = DEFAULT_GRID_PAGER_SETTINGS;
  private destroy$ = new Subject<void>();

  public requestList: any = [];
  public originalRequestList: any = [];
  //public approveOrDenyRequestDetails : any;
  public selectedEngagementDetail: any;
  public userAddDetails: any;
  public selectedModuleDetail: any;
  public selectedRemovalUserData: any;
  public selectedRequestId: any;
  public searchValue: string = '';

  displayRequestsLoader: boolean = false;

  public isEngagementRequestPopupOpen = false;
  public isApprovalUser = false;
  public isUserAddPopupOpen = false;
  public isModuleRequestPopupOpen = false;
  @ViewChild(RequestEngagementActivityPanelComponent) requestEngagementActivityPanelComponent!: RequestEngagementActivityPanelComponent;
  @ViewChild(RequestAddUserActivityPanelComponent) requestAddUserActivityPanelComponent!: RequestAddUserActivityPanelComponent;
  @ViewChild(RequestModuleActivityPanelComponent) requestModuleActivityPanelComponent!: RequestModuleActivityPanelComponent;
  @ViewChild(RequestRemoveUserActivityPanelComponent) requestRemoveUserActivityPanelComponent!: RequestRemoveUserActivityPanelComponent;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;

  public value = 50;
  public colors = [
    {
      to: 25,
      color: '#ffc000',

    },
    {
      from: 25,
      to: 50,
      color: '#0058e9',

    },
    {
      from: 50,
      to: 75,
      color: '#00338D',
    },
    {
      from: 75,
      color: '#4CAF50',
    },
  ];

  // public isRequestEngagementPopupOpen = false;
  // public isRequestUserPopupOpen = false;
  @ViewChild('anchor', { static: true }) anchor!: ElementRef;
  public loggedInUserRole: string | null = "";
  public readonly userRole = Roles;
  public selectedUserDetail: any;
  public requestStatus: string = "";
  public isUserRemovePopupOpen: boolean = false;
  public viewClosedRequest: boolean = false;
  public loggedInUserGuidId: any;
  newEngagementRequestCount: number | null = 0;
  newUserRequestCount: number | null = 0;
  newModuleRequestCount: number | null = 0;
  totalRequestCount: number = 0;
  completedRequestCount: number = 0;
  percentageCompletion: number = 0;
  switchChecked: boolean = false;
  percentageApproved: number = 0;
  approvedRequestCount: number = 0;
  public RequestStatusEnum = RequestStatusEnum;
  public userProfile: any;

  private readonly authUserService = inject(AuthUserService);
  private readonly requestService = inject(RequestService);
  private readonly engagementService = inject(EngagementService);
  private readonly engagementrequestService = inject(EngagementrequestService);
  private readonly userrequestService = inject(UserrequestService);
  private readonly modulerequestService = inject(ModulerequestService);
  private readonly refreshGridService = inject(RefreshGridService);
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private location = inject(Location);
  private spinner = inject(NgxSpinnerService);

  constructor() {
    this.refreshGridService.refreshRequestGrid.subscribe(value => {
      if (value)
        this.getRequests();
    })
  }

  ngOnInit(): void {
    this.displayRequestsLoader = true;
    this.spinner.show();
    if(localStorage.getItem('viewClosedRequest')) {
        this.switchChecked = localStorage.getItem('viewClosedRequest') === 'true';
    } else {
        this.switchChecked = false;
    }
    if (!localStorage.getItem('loggedInUserRole')) {
      this.authUserService.loggedInUserProfile.subscribe(userRole => {
        this.loggedInUserRole = userRole;
      })
    }
    else
      this.loggedInUserRole = localStorage.getItem('loggedInUserRole') ?? "";

    this.userProfile = JSON.parse(localStorage.getItem('userProfile') ?? "");
    this.getRequests();
    // this.getRequestDetailsForAppoveOrDeny(requestDetail.requestId)

  }

  public getRequests(): void {
    this.displayRequestsLoader = true;
    this.percentageApproved = 0;
    this.percentageCompletion = 0;
    this.spinner.show();
    let localStorageLoggedInId = localStorage.getItem('loggedInUserGuidId');
    this.loggedInUserGuidId = localStorageLoggedInId ?? this.authService.getLoggedInUserId();

    this.requestService
      .getRequestDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (x) => {
          this.originalRequestList = x.data;
          this.requestList = this.originalRequestList;
          this.displayRequestsLoader = false;
          this.spinner.hide();
          this.searchValue = "";
          this.newEngagementRequestCount = this.originalRequestList.filter((data:any) => data.requestType == RequestType.AddEngagement && data.requestStatus != RequestStatusEnum.Completed).length;
          this.newUserRequestCount = this.originalRequestList.filter((data:any) => data.requestType == RequestType.AddUser && data.requestStatus != RequestStatusEnum.Completed).length;
          this.newModuleRequestCount = this.originalRequestList.filter((data:any) => data.requestType == RequestType.AddModule && data.requestStatus != RequestStatusEnum.Completed).length;
          this.totalRequestCount = this.originalRequestList.length;
          this.completedRequestCount = this.originalRequestList.filter((data:any) => data.requestStatus == RequestStatusEnum.Completed).length;
          if (this.loggedInUserRole !== this.userRole.SupportUserRole) {
            this.getApprovedRequestData();
          }
          if(this.totalRequestCount != 0) {
            this.percentageCompletion = (this.completedRequestCount / this.totalRequestCount) * 100;
            this.percentageCompletion = parseInt(this.percentageCompletion.toFixed(2));
          }
          this.route.paramMap.subscribe(params => {
            let id = params.get("requestId");
            let request = this.originalRequestList.find((x: any) => x.requestId == id);
            if (request)
              this.onRequestPopup(request);
          });
          this.filterRecordsBySwitch();
        },
        error: (error) => {
          this.displayRequestsLoader = false;
          this.spinner.hide();
        }
      });
  }

  getApprovedRequestData() {
    // 2 means approved
    this.requestService.getAllRequestDetails(2, this.userProfile.id).subscribe({
      next: (x) => {
        this.approvedRequestCount = x.data.length;
        if(this.totalRequestCount != 0) {
          this.percentageApproved = (this.approvedRequestCount / ((this.totalRequestCount) + this.approvedRequestCount)) * 100;
          this.percentageApproved = parseInt(this.percentageApproved.toFixed(2));
        }
      },
    });
  }

  public onFilter(value: Event): void {
    if(this.switchChecked) {
      this.dataBinding.skip = 0;
      this.requestList = process(this.originalRequestList.filter((x: any) => x.requestStatus === "Completed"), {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'clientName',
            operator: 'contains',
            value: value,
          },
        ],
      },
      }).data;
    } else {
      this.dataBinding.skip = 0;
      this.requestList = process(this.originalRequestList.filter((x: any) => x.requestStatus !== "Completed"), {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'clientName',
            operator: 'contains',
            value: value,
          },
        ],
      },
      }).data;
    }

  }

  onEngagementRequestCellClick(requestDetail: any): void {
    this.onRequestPopup(requestDetail);
    this.appendToPath(requestDetail.requestId);
  }

  onRequestPopup(requestDetail: any): void {
    this.requestStatus = requestDetail?.requestStatus;
    if (this.loggedInUserRole === this.userRole.EngagementApproverUserRole) {
      this.isApprovalUser = true;
    }
    if (requestDetail.requestType === RequestType.AddEngagement) {
      this.getEngagementDetailsByRequestId(requestDetail.requestId);
      this.isEngagementRequestPopupOpen = true;
      this.requestEngagementActivityPanelComponent.open();
    } else if (requestDetail.requestType === RequestType.AddUser) {
      this.getUserDetailsByRequestId(requestDetail.requestId);
      this.isUserAddPopupOpen = true;
      this.requestAddUserActivityPanelComponent.open();
    } else if (requestDetail.requestType === RequestType.AddModule) {
      this.getModuleDetailsByRequestId(requestDetail.requestId);
      this.isModuleRequestPopupOpen = true;
      this.requestModuleActivityPanelComponent.open();
    } else if (requestDetail.requestType === RequestType.RemoveUser) {
      this.getUserRemoveDetailsByRequestId(requestDetail.requestId);
      this.isUserRemovePopupOpen = true;
      this.requestRemoveUserActivityPanelComponent.open();
    }
  }

  // #region Approver & Support User Popups

  // #region Engagement

  public getEngagementDetailsByRequestId(requestId: number): void {
    this.engagementrequestService
      .getEngagementDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.selectedEngagementDetail = x.data;
        this.selectedRequestId = requestId;
      });
  }

  onEngagementRequestPopupClose(): void {
    this.isEngagementRequestPopupOpen = false;
    this.requestStatus = "";
    //this.isApproveOrDenyUserPopupOpen = false;
    this.selectedEngagementDetail = null;
    this.reset();
  }

  // #endregion

  // #region Module

  public getModuleDetailsByRequestId(requestId: number): void {
    this.modulerequestService
      .getModuleRequestDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.selectedModuleDetail = x.data;
        this.selectedRequestId = requestId;
      });
  }

  onModuleRequestPopupClose(): void {
    this.isModuleRequestPopupOpen = false;
    this.requestStatus = "";
    this.selectedModuleDetail = null;
    this.reset();
  }

  // #endregion

  // #region Add User

  public getUserDetailsByRequestId(requestId: number): void {
    this.userrequestService.getUserDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.userAddDetails = x.data;
        this.selectedRequestId = requestId;
      });
  }

  onUserAddPopupClose(): void {
    //this.isApproveOrDenyEngagementPopupOpen = false;
    this.isUserAddPopupOpen = false;
    this.requestStatus = "";
    this.userAddDetails = null;
    this.reset();
  }

  // #endregion

  // #region Remove User

  public getUserRemoveDetailsByRequestId(requestId: number): void {
    this.userrequestService.getUserRemovalDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.selectedRemovalUserData = x.data;
        this.selectedRequestId = requestId;
      });
  }

  closeRemoveUserPopup(): void {
    this.isUserRemovePopupOpen = false;
    this.selectedRemovalUserData = null;
    this.requestStatus = "";
    this.reset();
  }

  // #endregion

  // #endregion

  appendToPath(segment: string) {
  const currentPath = this.location.path();
   const pathParts = currentPath.split('/').filter(part => part);
   if (pathParts.length > 1) {
     // Assume that the segment is at the end
     pathParts[pathParts.length - 1] = segment;
   } else {
     pathParts.push(segment);
   }
   const newPath =  `/${pathParts.join('/')}`;
   this.location.replaceState(newPath);
  }

  reset(): void {
    this.refreshGridService.emitNotificationBellRefresh();
    this.router.navigate(['/Request']);
  }

  refreshRequestGrid(): void {
    this.getRequests();
  }

  openTeamsChat(email: any) {
    const teamsUrl = `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
    window.open(teamsUrl, '_blank');
  }

  public openEmail(email: string): void {
    window.location.href = `mailto:${email || ''}`;
  }

  public selectViewClosedRequest(): void {
    localStorage.setItem('viewClosedRequest', this.switchChecked.toString());
    this.filterRecordsBySwitch();
  }

  filterRecordsBySwitch() {
    if (this.switchChecked) {
      this.requestList = this.originalRequestList.filter((x: any) => x.requestStatus === "Completed");
    }
    else {
       this.requestList = this.originalRequestList.filter((x: any) => x.requestStatus !== "Completed");
    }
  }

  ngOnDestroy() {
    localStorage.removeItem('viewClosedRequest');
     this.destroy$.next();
    this.destroy$.complete();
  }
}
